import { ComponentPortal, ComponentType, Portal, TemplatePortal } from '@angular/cdk/portal';
import { Service, TemplateRef, ViewContainerRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { mergeMap, startWith } from 'rxjs/operators';

@Service()
export class SidenavRightService {
  sidenav: MatSidenav;
  private viewContainerRef: ViewContainerRef;
  private readonly sidenavPortal$ = new Subject<Portal<any> | null>();
  private readonly iconPortal$ = new Subject<Portal<any> | null>();

  // Wait until after Angular's change detection runs before emitting (avoids "expression changed after it was checked" / NG0100 error)
  // noinspection JSUnusedGlobalSymbols - used in mng-frame template
  readonly sidenavPortal = this.sidenavPortal$.pipe(
    startWith(null),
    mergeMap((value) => Promise.resolve().then(() => value))
  );
  // noinspection JSUnusedGlobalSymbols - used in mng-frame template
  readonly iconPortal = this.iconPortal$.pipe(
    startWith(null),
    mergeMap((value) => Promise.resolve().then(() => value))
  );

  setViewContainerRef(vcr: ViewContainerRef) {
    this.viewContainerRef = vcr;
  }

  setSidenavContent(componentOrTemplateRef: ComponentType<any> | TemplateRef<any>) {
    let portal: Portal<any>;
    if (componentOrTemplateRef instanceof TemplateRef) {
      const vcr = this.viewContainerRef ?? null;
      portal = new TemplatePortal(componentOrTemplateRef, vcr);
    } else {
      portal = new ComponentPortal(componentOrTemplateRef);
    }
    this.sidenavPortal$.next(portal);
  }

  setIconContent(componentOrTemplateRef: ComponentType<any> | TemplateRef<any>) {
    let portal: Portal<any>;
    if (componentOrTemplateRef instanceof TemplateRef) {
      const vcr = this.viewContainerRef ?? null;
      portal = new TemplatePortal(componentOrTemplateRef, vcr);
    } else {
      portal = new ComponentPortal(componentOrTemplateRef);
    }
    this.iconPortal$.next(portal);
  }

  clearSidenavPortal() {
    void this.close();
    this.sidenavPortal$.next(null);
    this.iconPortal$.next(null);
    this.viewContainerRef = null;
  }

  open() {
    return this.sidenav.open();
  }

  toggle() {
    return this.sidenav.toggle();
  }

  close() {
    return this.sidenav.close();
  }
}
